/// <amd-module name="SuiteCommerce.FeaturedCategory.CCTConfiguration"/>
define("SuiteCommerce.FeaturedCategory.CCTConfiguration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CCTConfiguration = void 0;
    var ButtonStyleOptions = {
        '1': 'button-style-one',
        '2': 'button-style-two',
        '3': 'button-style-three',
    };
    var HeaderPositionOptions = {
        '1': 'left',
        '2': 'right',
        '3': 'center',
    };
    var SortFieldOptions = {
        '1': { sortfieldname: 'relevance', direction: 'desc' },
        '2': { sortfieldname: 'pricelevel5', direction: 'asc' },
        '3': { sortfieldname: 'pricelevel5', direction: 'desc' },
        '4': { sortfieldname: 'custitem_ns_sc_ext_ts_7_amount', direction: 'desc' },
        '5': { sortfieldname: 'custitem_ns_sc_ext_ts_30_amount', direction: 'desc' },
        '6': { sortfieldname: 'custitem_ns_sc_ext_ts_90_amount', direction: 'desc' },
        '7': { sortfieldname: 'custitem_ns_sc_ext_ts_365_amount', direction: 'desc' },
        '8': { sortfieldname: 'custitem_ns_sc_ext_ts_7_quantity', direction: 'desc' },
        '9': { sortfieldname: 'custitem_ns_sc_ext_ts_30_quantity', direction: 'desc' },
        '10': { sortfieldname: 'custitem_ns_sc_ext_ts_90_quantity', direction: 'desc' },
        '11': { sortfieldname: 'custitem_ns_sc_ext_ts_365_quantity', direction: 'desc' },
    };
    var NumberOfItemsOptions = {
        '1': 2, '2': 4, '3': 6, '4': 8, '5': 10, '6': 12, '7': 14, '8': 16, '9': 18, '10': 20, '11': 22, '12': 24
    };
    var ColumnsPerRowSupportedOptions = {
        '1': 12, '2': 6, '3': 4, '4': 3
    };
    var ColumnsPerRowSupportedPhoneOptions = {
        '1': 12, '2': 6
    };
    var CCTConfiguration = /** @class */ (function () {
        function CCTConfiguration() {
        }
        CCTConfiguration.getButtonStyle = function (option) {
            return ButtonStyleOptions[option] ? ButtonStyleOptions[option] : '1';
        };
        CCTConfiguration.getHeaderPosition = function (option) {
            return HeaderPositionOptions[option] ? HeaderPositionOptions[option] : '';
        };
        CCTConfiguration.getSortField = function (option) {
            return SortFieldOptions[option] ? SortFieldOptions[option] : SortFieldOptions['1'];
        };
        CCTConfiguration.getNumberOfItems = function (option, defaultOption) {
            if (NumberOfItemsOptions[option])
                return NumberOfItemsOptions[option];
            return NumberOfItemsOptions[defaultOption];
        };
        CCTConfiguration.getColumnsPerRow = function (option) {
            return ColumnsPerRowSupportedOptions[option] ? ColumnsPerRowSupportedOptions[option] : ColumnsPerRowSupportedOptions['3'];
        };
        CCTConfiguration.getColumnsPerRowPhone = function (option) {
            return ColumnsPerRowSupportedPhoneOptions[option] ? ColumnsPerRowSupportedPhoneOptions[option] : ColumnsPerRowSupportedPhoneOptions['1'];
        };
        return CCTConfiguration;
    }());
    exports.CCTConfiguration = CCTConfiguration;
});
